module.exports = __webpack_public_path__ + "ejemploa1(c).png?f2111c2268894799cd87523167ae90c0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ejemploa1(c).png
// module id = 502
// module chunks = 0